import {applyMiddleware, compose, createStore, combineReducers} from "redux";
import thunk from 'redux-thunk';

import userReducer from "./reducers/user";
import { sidebarCollapse } from "./reducers/sidebarCollapse";

const reducers = () => {
    // Store Enhancers
    const enhancers = [];

    // Redux Dev Tools (solo dev)
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__
        if (typeof devToolsExtension === "function") {
            enhancers.push(devToolsExtension());
        }
    }

    // Middleware
    const middleware = [
        thunk,
    ];

    // Store
    const store = createStore(
        combineReducers({
            user: userReducer,
            sidebarCollapse: sidebarCollapse 
        }),
        {},
        compose(applyMiddleware(...middleware), ...enhancers)
    );

    return store;
}

export default reducers;